import { FormattedDate } from '@cmg/i18n';
import React from 'react';

import {
  SInfoColumn,
  SInfoColumnText,
  SInfoColumnTitle,
  SInfoContent,
} from './AllocationLastModifiedInfo.styles';

type Props = {
  name?: string | null;
  submittedOn?: string | null;
};

const AllocationLastModifiedInfo: React.FC<Props> = ({ name, submittedOn }) => {
  return (
    <SInfoContent className="form-section">
      <SInfoColumn>
        <SInfoColumnTitle>Submitted By</SInfoColumnTitle>
        <SInfoColumnText>{name || ' '}</SInfoColumnText>
      </SInfoColumn>
      <SInfoColumn>
        <SInfoColumnTitle>Submitted On</SInfoColumnTitle>
        <SInfoColumnText>
          <FormattedDate value={submittedOn} format="short" emptyValueLabel="" />
        </SInfoColumnText>
      </SInfoColumn>
    </SInfoContent>
  );
};

export default AllocationLastModifiedInfo;
